module.exports = __webpack_public_path__ + "static/media/IncreasingPositiveAttitude.bf860c34.jpg";